// extracted by mini-css-extract-plugin
export default {"container":"about_container__SXb4g","img":"about_img__W4eQT","img1":"about_img1__z+Dgw","container--dark":"about_container--dark__TF4On"};